module.exports = __webpack_public_path__ + "img/chinesecompany202.68614f4d.png";